import en from './locale/en';
import zh_CN from './locale/zh_CN';
import { withBorderchatVocabulary } from './borderchatVocabulary';

export default {
  en: withBorderchatVocabulary(en),
  zh_CN: withBorderchatVocabulary(zh_CN, true),
};
